import {Platform} from 'react-native';

/**
 * Which client this is and which version it runs, as the forced-update policy names them (QUI-183, Sol
 * forced-update). Web builds carry REACT_APP_VERSION and REACT_APP_BUILD_ID (craco.config.js); the apps read their
 * store version.
 */
export const BUILD_ID = process.env.REACT_APP_BUILD_ID || '';

export function appPlatform() {
  if (Platform.OS === 'web') return 'web-player';
  if (Platform.OS === 'ios' || Platform.OS === 'android') return Platform.OS;
  return '';
}

export function appVersion() {
  if (Platform.OS === 'web') return process.env.REACT_APP_VERSION || '';
  try {
    // eslint-disable-next-line global-require
    return require('react-native-device-info').default.getVersion() || '';
  } catch (_) {
    return '';
  }
}
